import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import ChatInput from '@/components/chat/ChatInput';
import urlStore from '@/store/chat/urlStore';
import inputTypeStore from '@/components/input-file/input-type';
import ScrollView from '@/ui/scroll-view';
import ExampleItem from '@/components/examples/example-item';
import homeStore from '../store';
import PromptList from './PromptList';
import './style.scss';

const AgentCustomInput = () => {
  const { showCustomInputPage, currentAgentInfo, currentAgentId } = homeStore;
  const {
    greeting,
    input_func,
    input_tip,
    input_tip_defalt,
    saylist_detail = [],
    saylist_example = [],
    title,
  } = currentAgentInfo || {};

  const handleSendAgent = extras => {
    const { input } = extras;
    const { id: agentId } = currentAgentInfo;
    // if (!input) return;
    urlStore.newAiAgentChat(agentId, input, {
      ...inputTypeStore.getSendParams(),
    });
  };

  useEffect(() => {
    // 清空其他地方已上传的文件，避免带到这里
    inputTypeStore.reset();

    if (!currentAgentId) return;
    homeStore.getAgentInfo(currentAgentId);
  }, [currentAgentId]);

  console.log(
    '>>> showCustomInputPage, currentAgentInfo',
    !showCustomInputPage,
    !currentAgentInfo
  );
  if (!showCustomInputPage || !currentAgentInfo) {
    return null;
  }

  return (
    <ScrollView className="h-0 flex-grow overflow-y-scroll pb-40px">
      <div className="w-800px mt-72px mx-auto flex flex-col items-start justify-center relative z-2">
        <div className="w-full text-34px leading-48px font-bold-500 text-center mb-32px">
          {greeting || title}
        </div>
        <div>
          <ChatInput
            agentInfo={currentAgentInfo}
            scene="recommendAgent"
            classname={[
              'w-800px',
              'mx-auto',
              'border-1px',
              'border-solid',
              'border-black',
              '!rounded-12px',
              'border-opacity-100',
            ]}
            style={{ boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.12)' }}
            handleSendAgent={handleSendAgent}
            placeholder={input_tip || input_tip_defalt}
          />
        </div>
        <PromptList data={saylist_detail} />
        <div className="w-full flex items-start justify-between mt-40px">
          {saylist_example?.length > 0 &&
            saylist_example.slice(0, 3).map(item => {
              return <ExampleItem key={item.id} data={item} />;
            })}
        </div>
      </div>
      {/* 渐变底色 */}
      <div className="absolute w-full h-full z-1 left-0 top-0 flex flex-col pointer-events-none">
        <div style={{ height: 'calc(100vh - 500px)' }}></div>
        <div
          className="bg-black h-0 flex-grow w-full"
          style={{
            background: `linear-gradient(to bottom,rgba(255,255,255,0) 0,rgba(255,255,255,1) 500px)`,
          }}
        ></div>
      </div>
    </ScrollView>
  );
};

export default observer(AgentCustomInput);
